import React from 'react'
import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import Delete from '@mui/icons-material/Delete'
import { useTranslation } from 'react-i18next'
import { Dialog } from '@carsys/ui'

import type { DeleteIssue } from './to-issues'
import { DeleteReasonDropdown, Option } from './DeleteReasonDropdown'
import { IssueList } from './IssueList'

interface WarningDialogProps {
  deletedItemString: string
  scope: string
  deleteReasons?: Option[]
  onCancel: () => void
  onConfirm: (reason?: string) => void
  rejections: []
  warnings: DeleteIssue[]
  reasonIsRequired: boolean
}

export function WarningDialog(props: WarningDialogProps) {
  const { t } = useTranslation()
  const [deleteReason, setDeleteReason] = React.useState<string | undefined>(undefined)

  const reasonIsSelected = Boolean(deleteReason)

  return (
    <Dialog fullWidth open>
      <DialogTitle>{t('DeleteFlow.WarningDialog.Title', { item: props.deletedItemString })}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('DeleteFlow.WarningDialog.Description', { item: props.deletedItemString })}</DialogContentText>
        <IssueList
          deletedItemString={props.deletedItemString}
          scope={props.scope}
          rejections={props.rejections}
          warnings={props.warnings}
        />
        {props.deleteReasons ? (
          <DeleteReasonDropdown
            deletedItemString={props.deletedItemString}
            onChange={setDeleteReason}
            options={props.deleteReasons}
            value={deleteReason}
            reasonIsRequired={props.reasonIsRequired}
          />
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={props.onCancel}>
          {t('DeleteFlow.WarningDialog.Cancel')}
        </Button>
        <Button
          color='primary'
          disabled={props.reasonIsRequired && !reasonIsSelected}
          onClick={() => props.onConfirm(deleteReason)}
          startIcon={<Delete />}
          variant='contained'
          autoFocus
          sx={{
            '&:hover,&:focus': {
              backgroundColor: 'primary.dark'
            }
          }}
        >
          {t('DeleteFlow.WarningDialog.Confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
